import { Phone, Video, ArrowRight, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PhoneAlternative() {
  const scrollToBooking = () => {
    const el = document.querySelector("#termin-buchen");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="telefon"
      data-testid="phone-alternative-section"
      className="py-16 lg:py-20 bg-white"
      aria-label="Telefonberatung als Alternative"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-green-50 to-cyan-50 rounded-3xl border border-green-100/60 overflow-hidden">
          <div className="grid md:grid-cols-2 gap-8 p-8 md:p-12 items-center">
            {/* Text */}
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 border border-green-200 rounded-full mb-5">
                <Phone className="h-4 w-4 text-green-600" />
                <span className="text-sm font-semibold text-green-700">Auch per Telefon</span>
              </div>

              <h2 className="font-['Manrope'] text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 leading-tight mb-4">
                Lieber per Telefon?<br />
                <span className="text-green-600">Kein Problem!</span>
              </h2>

              <p className="text-lg text-slate-600 leading-relaxed mb-4">
                Nicht jeder möchte eine Video-Beratung — und das ist völlig in Ordnung.
                Wir beraten Sie genauso gerne und ausführlich am Telefon.
              </p>

              <p className="text-lg text-slate-600 leading-relaxed mb-6">
                Rufen Sie uns einfach an oder buchen Sie einen Rückruf-Termin.
                Wir melden uns dann bei Ihnen — ganz ohne Technik-Stress.
              </p>

              <div className="space-y-4">
                {/* Direct call button - big and prominent */}
                <a
                  href="tel:+491637917044"
                  data-testid="phone-call-btn"
                  className="flex items-center justify-center gap-3 bg-green-600 hover:bg-green-700 text-white rounded-2xl px-8 py-5 text-xl font-bold shadow-lg hover:shadow-xl transition-all active:scale-[0.98] w-full sm:w-auto"
                >
                  <Phone className="h-6 w-6" />
                  0163 791 7044
                </a>
                <p className="text-sm text-slate-500 text-center sm:text-left">
                  Mo–Fr, 10:00–14:00 Uhr — Oder hinterlassen Sie eine Nachricht
                </p>
              </div>
            </div>

            {/* Visual side */}
            <div className="flex flex-col gap-4">
              {/* Comparison cards */}
              <div className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-11 w-11 bg-cyan-50 rounded-xl flex items-center justify-center">
                    <Video className="h-5 w-5 text-cyan-700" />
                  </div>
                  <div>
                    <p className="text-base font-bold text-slate-800">Video-Beratung</p>
                    <p className="text-sm text-slate-500">Per Bildschirm — wie ein persönliches Gespräch</p>
                  </div>
                </div>
                <ul className="space-y-2 text-sm text-slate-600">
                  <li className="flex items-start gap-2"><span className="text-cyan-600 font-bold mt-0.5">+</span> Sie sehen Ihren Berater</li>
                  <li className="flex items-start gap-2"><span className="text-cyan-600 font-bold mt-0.5">+</span> Dokumente gemeinsam ansehen</li>
                  <li className="flex items-start gap-2"><span className="text-cyan-600 font-bold mt-0.5">+</span> Online-Termin buchen</li>
                </ul>
                <Button onClick={scrollToBooking} className="mt-4 bg-cyan-700 hover:bg-cyan-600 text-white rounded-xl w-full h-12 text-base font-semibold active:scale-[0.98]">
                  Video-Termin buchen <ArrowRight className="h-4 w-4 ml-1" />
                </Button>
              </div>

              <div className="bg-white rounded-2xl p-6 border-2 border-green-200 shadow-sm relative">
                <div className="absolute -top-3 right-4 bg-green-600 text-white text-xs font-bold px-3 py-1 rounded-full">
                  Einfache Alternative
                </div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-11 w-11 bg-green-50 rounded-xl flex items-center justify-center">
                    <Phone className="h-5 w-5 text-green-600" />
                  </div>
                  <div>
                    <p className="text-base font-bold text-slate-800">Telefon-Beratung</p>
                    <p className="text-sm text-slate-500">Ganz einfach — nur ein Anruf</p>
                  </div>
                </div>
                <ul className="space-y-2 text-sm text-slate-600">
                  <li className="flex items-start gap-2"><span className="text-green-600 font-bold mt-0.5">+</span> Keine Technik nötig</li>
                  <li className="flex items-start gap-2"><span className="text-green-600 font-bold mt-0.5">+</span> Einfach anrufen oder Rückruf buchen</li>
                  <li className="flex items-start gap-2"><span className="text-green-600 font-bold mt-0.5">+</span> Gleiche professionelle Beratung</li>
                </ul>
                <a href="tel:+491637917044" className="mt-4 flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white rounded-xl w-full h-12 text-base font-semibold transition-all active:scale-[0.98]">
                  <Phone className="h-4 w-4" /> Jetzt anrufen
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
